'use client';

import { useTranslations } from 'next-intl';
import { useExecutionStateDistribution } from '../../hooks/dashboard/useExecutionStateDistribution';
import {
  buildExecutionOutcomePostureItems,
  sumPostureCounts,
  type ExecutionOutcomeKey,
} from './posture-items';
import { PostureCard } from './PostureCard';
import { useOpenListFromHome } from './useOpenListFromHome';

type ExecutionsOutcomePostureCardProps = {
  applicationId: string;
};

export function ExecutionsOutcomePostureCard({
  applicationId,
}: ExecutionsOutcomePostureCardProps) {
  const t = useTranslations('home.posture');
  const tStatus = useTranslations('designSystem.executions.status');
  const { data, isLoading } = useExecutionStateDistribution(applicationId);
  const { openList, openListContextMenu } = useOpenListFromHome({
    applicationId,
  });
  const items = buildExecutionOutcomePostureItems({
    counts: {
      COMPLETED: data?.completed ?? 0,
      RUNNING: data?.running ?? 0,
      FAILED: data?.failed ?? 0,
      BLOCKED: data?.blocked ?? 0,
      ABORTED: data?.aborted ?? 0,
      PAUSED: data?.stopped ?? 0,
    },
  }).map((item) => ({ ...item, label: tStatus(item.key) }));

  return (
    <PostureCard<ExecutionOutcomeKey>
      title={t('executionsByOutcome')}
      total={sumPostureCounts(items)}
      items={items}
      isLoading={isLoading}
      emptyLabel={t('noExecutions')}
      onSelect={(outcome) =>
        openList({ list: 'executions', filters: { statusFilter: [outcome] } })
      }
      onTitleClick={() =>
        openList({ list: 'executions', filters: { statusFilter: [] } })
      }
      onTitleContextMenu={(event) =>
        openListContextMenu(event, { list: 'executions' })
      }
    />
  );
}
